import { EngagementState } from "@oysterhr/schema"

export const getEngagementStateFlags = (state?: EngagementState) => ({
  isEngaged: state === EngagementState.Engaged,
  isAssistedSetup: state === EngagementState.AssistedSetup,
  isInProgress: state === EngagementState.InProgress,
  isWaitingForSignature: state === EngagementState.WaitingForSignature,
  isDraft: state === EngagementState.Draft,
  isTerminated: state === EngagementState.Terminated,
})
